import { render, staticRenderFns } from "./MobileLinks.vue?vue&type=template&id=5143b839&scoped=true&"
import script from "./MobileLinks.vue?vue&type=script&lang=ts&"
export * from "./MobileLinks.vue?vue&type=script&lang=ts&"
import style0 from "./MobileLinks.vue?vue&type=style&index=0&id=5143b839&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143b839",
  null
  
)

export default component.exports